<script setup lang="ts">
// import JsonViewer from 'vue-json-viewer'
// import 'vue-json-viewer/style.css'
const props = defineProps<{ value: object; sort?: boolean; expandDepth?: number; class?: any }>()

// const JsonViewer = ref(null)               // will store the component
// const cssLoaded = ref(false)               // track when CSS is injected

// onMounted(async () => {
//   // Only now do we pull in the library
//   const mod = await import('vue-json-viewer')
//   // Inject its CSS as a <link> tag, not inline
//   if (!cssLoaded.value) {
//     const link = document.createElement('link')
//     link.rel = 'stylesheet'
//     link.href = '/node_modules/vue-json-viewer/style.css'
//     document.head.appendChild(link)
//     cssLoaded.value = true
//   }
//   JsonViewer.value = mod.default
// })
</script>

<template>
  <json-viewer
    :class="props.class"
    :value="value"
    :sort="sort"
    :expand-depth="expandDepth"
  ></json-viewer>
</template>
